function MarketPreference(props: { marketPreference: any }) {
  const channelCoverageKeys = [
    "regulatory_compliance",
    "importation_clearance",
    "offline_retail",
    "online",
    "food_service",
  ];

  const keyCapabilitiesKeys = [
    "cold_and_frozen_warehousing",
    "ambient_warehousing",
    "retail_distribution",
    "sales",
    "marketing",
  ];

  const getChannelCoverageLabel = (label: string) => {
    if (label === "cold_and_frozen_warehousing") {
      return "Cold And Frozen Warehousing";
    } else {
      return label.replace(/_/g, " ");
    }
  };

  return (
    <div className="pref-container">
      {props.marketPreference?.length !== 0 &&
        props.marketPreference?.map((item: any) => {
          return (
            <div key={item.id} className="pref-card">
              <div className="country px-[10px] py-2 gap-2 border-b">
                {item.regions.country_img && (
                  <img
                    width={22}
                    height={16}
                    src={item.regions.country_img}
                    alt="flag"
                    className="mr12px"
                  />
                )}
                <span className="font13-medium gray-800">
                  {item.regions.name}
                </span>
              </div>
              <div className="flex flex-col gap-[10px]">
                <div className="preference">
                  <p className="font12-medium grey-800 pb-[8px] m-[0]">
                    Key Channel Coverage{" "}
                  </p>
                  <ul className="list-disc pl-5 m-[0]">
                    {Object.keys(item)
                      .filter(
                        (element) =>
                          channelCoverageKeys.includes(element) && item[element]
                      )
                      .map((element) => {
                        return (
                          <li
                            className="item font12-regular gray-600"
                            key={element}
                          >
                            {getChannelCoverageLabel(element)}
                          </li>
                        );
                      })}
                  </ul>
                </div>
                <div className="preference">
                  <p className="font12-medium grey-800 pb-[8px] m-[0]">
                    Key Capabilities{" "}
                  </p>

                  <ul className="list-disc pl-5 m-[0]">
                    {Object.keys(item)
                      .filter(
                        (element) =>
                          keyCapabilitiesKeys.includes(element) && item[element]
                      )
                      .map((element) => {
                        return (
                          <li
                            className="item font12-regular gray-600"
                            key={element}
                          >
                            {getChannelCoverageLabel(element)}
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default MarketPreference;
